"use client";

import PageSection from "@/common/page-section.common";
import {
  Header,
  HowItWorks,
  LandingPage,
  WelcomeSection,
  WhoCanApply,
} from "@/components";
import FAQ from "@/components/faq/faq.component";
import LogoutHeader from "@/components/logout/LogoutHeader";
import RequiredDocuments from "@/components/required-documents/required-documents.component";
import { Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

export default function HomeClient() {
  const [isTokenValid, setIsTokenValid] = useState(null);
  const t = useTranslations();

  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (token) {
      console.log(token)
      try {
        const payload = token.split(".")[1];
        const decodedPayload = JSON.parse(atob(payload));
        const expiryTime = decodedPayload?.exp;
  
        if (!expiryTime || isNaN(expiryTime)) {
          throw new Error("Invalid or missing expiry time");
        }
  
        setIsTokenValid(expiryTime * 1000 >= Date.now());
      } catch (error) {
        console.error("Token error:", error);
        localStorage.removeItem("token");
        setIsTokenValid(false);
      }
    } else {
      setIsTokenValid(false);
    }
  }, []);
  

  return isTokenValid ? (
    <div className="h-full">
      <LogoutHeader />
      <LandingPage />
      <PageSection variant="green">
        <Typography sx={{ textAlign: "center" }} color="#fff">
          © {" "}
          {t("Design and developed by 2025 Vidarbha Infotech Private Limited")}
        </Typography>
      </PageSection>
    </div>
  ) : (
    <>
      <Header />
      <WelcomeSection />
      <HowItWorks />
      <WhoCanApply />
      <RequiredDocuments />
      <FAQ />
      <PageSection variant="green">
        <Typography sx={{ textAlign: "center" }} color="#fff">
          © {" "}
          {t("Design and developed by 2025 Vidarbha Infotech Private Limited")}
        </Typography>
      </PageSection>
    </>
  );
}
